/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import {State} from "ui/feature/root/FormReducer";
import {fetchQuery} from "react-relay";
import environment from "constants/environment";
import query from "ui/feature/root/play/PollPlayStepsQuery";
import {PollPlayStepsQuery} from "ui/feature/root/play/__generated__/PollPlayStepsQuery.graphql";

// todo: make this similar to the note select or the bar select
export default function UsePollPlaySteps(state: State): boolean {
    const [isStatusComplete, setIsStatusCompleted] = React.useState(false);
    const [shouldPoll, setShouldPoll] = React.useState<boolean>(true)

    React.useEffect(() => {
        if (!state.pieceId || !shouldPoll) {
            return;
        }
        const statusObservable = fetchQuery<PollPlayStepsQuery>(environment, query, {
            piece_id: state.pieceId
        })
            .poll(2000)
            .subscribe({
                start: () => {
                    console.log("query started");
                },
                error: (err: Error) => {
                    console.log("query error", err);
                },
                complete: () => {
                    console.log("on complete");
                },
                next: (data) => {
                    console.log("polling in play");
                    const status = data.music_viewer.piece.status;
                    if (status === "COMPLETE") {
                        setIsStatusCompleted(true);
                        setShouldPoll(false);
                    } else if (status === "PROCESSING" || status === "UPLOADING") {
                        setShouldPoll(true);
                    } else {
                        setShouldPoll(false);
                    }
                }
            });
        return () => {
            statusObservable.unsubscribe();
        };
    }, [state.pieceId, shouldPoll]);

    return isStatusComplete;
}